var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanDarkDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Blue-Tick",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2043",
    "data-name": "Group 2043"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#1450ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_3_",
    "data-name": "check (3)",
    d: "M9.655,6,5.767,9.888,4,8.12",
    transform: "translate(0.173 -0.816)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanDarkDoneIcon);
export default __webpack_public_path__ + "static/media/plan-dark-done-icon.26a20eb1ba40d1bd50f1efbb22a1b1b9.svg";
export { ForwardRef as ReactComponent };